const ITEMS = [
  "Napa Valley", "Sonoma Coast", "Oakville", "Russian River Valley", "Rutherford",
  "Carneros", "Howell Mountain", "Dry Creek Valley", "Stags Leap", "Alexander Valley",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display italic font-light text-2xl md:text-3xl text-[#364132] px-10 md:px-14 whitespace-nowrap">
          {item}
        </span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#B89B67] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="ava-marquee" className="hairline-t hairline-b py-7 overflow-hidden bg-[#F3EFE6]">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
